<template>
    <div class="MainMenuBox">
        <div class="Container">
            <div class="Box">
                <nav class="MainMenu">
                    <div class="NavOpenButton"><a @click="this.menu($event)" style="cursor:pointer;"><img src="/images/NavButtonIcon.png" srcset="/images/NavButtonIconRetina.png 2x" alt=""/></a></div>
                    <ul>                    
                        <li>
                            <router-link  @click.prevent="this.closeMenu()" :to="{'name':'Home'}"  active-class="SelectedItem" exact>Home</router-link>          
                        </li>
                        <li>
                            <router-link @click.prevent="this.closeMenu()" :to="{'name' : 'CatalogsViews'}"  active-class="SelectedItem" exact>{{ this.risorse["Cataloghi"] }}</router-link>
                        </li>
                        <li>
                            <router-link @click.prevent="this.closeMenu()" :to="{'name' : 'Backorder'}"  active-class="SelectedItem" exact>{{ this.risorse["Backorder"] }}</router-link>
                        </li>
                        <!--<li>
                            <router-link @click.prevent="this.closeMenu()" :to="{'name' : 'orderForm'}"  active-class="SelectedItem" exact>{{ this.risorse['orderForm']}}</router-link>
                        </li>-->
                        <li>
                            <router-link @click.prevent="this.closeMenu()" :to="{'name' : 'Documenti'}"  active-class="SelectedItem" exact>{{ this.risorse['fatture']}}</router-link>
                        </li>
                        <li v-for="link in this.linkPagine" :key="link.IdPagina">
                            <router-link @click.prevent="this.closeMenu()"  :to="'/home/pages/'+link.Permalink">{{link.Etichetta}}</router-link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>

import MenuService from '@/services/menu.service.js';
import {risorseMixin} from "@/mixin.js";

export default {    
    name: "Menu",
    data(){
        return {
            linkPagine: []
        }
    }, 
    mixins:[risorseMixin],  
    methods: {
        menu(e)
        {           
            e.stopPropagation();
            if ($('body').hasClass('menumobile')) {
                $('body').removeClass('menumobile')
            }
            else {
                $('body').addClass('menumobile')
            }
        },
        closeMenu(){
            $('body').removeClass('menumobile');
        }

    }, 
    mounted: function(){
        MenuService.getMenuByTipo(this.$store.getters.getToken, "HEADER", this.$store.getters.getLingua, "B2B").then(
            (data) => {                        
                if(!data){
                    this.$router.push("/")
                }
                else{
                    this.linkPagine = data;
                }               
            }         

        ).catch(
            (err) => {console.log(err)}
        )

    }
}
</script>